export function IlustracaoAutofalante(props) {
  return (
    <svg
      width={70}
      height={71}
      viewBox="0 0 70 71"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.745 57.48c14.172 1.543 55.457-12.99 38.108-37.214-17.35-24.224-50.339.353-52.044 14.9-1.7 14.547 3.602 21.191 13.936 22.314z"
        fill="#FFE4CF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M44.863 46.92h5.333V14.567h-5.333V46.92z"
        fill="#FFFFFE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.959 24.16v13.342l16.905 5.919-.125-25.25-16.78 5.989z"
        fill="#FF7A5C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.505 38.736h12.92V22.818h-12.92v15.918z"
        fill="#FFFFFE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.58 52.307l-2.466.77h-1.969l-1.844-1.031-.513-12.773h6.792v13.034z"
        fill="#FF7A5C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M49.498 44.827a1.866 1.866 0 01-1.864 1.864 1.867 1.867 0 01-1.865-1.864V16.751c0-1.028.837-1.865 1.865-1.865s1.864.837 1.864 1.865v28.076zm-5.615-3.37a.46.46 0 01-.61.436l-13.888-4.761a.494.494 0 01-.121-.062.825.825 0 01-.34-.666v-11.23c0-.263.127-.512.34-.666a.462.462 0 01.121-.062l13.888-4.761a.453.453 0 01.417.061.46.46 0 01.193.375v21.336zm-12.714-1.196c-.018.043-.04.083-.063.123l-.01.017a4.668 4.668 0 01-4.519 3.483c-.482 0-.992-.098-1.558-.299a.46.46 0 01-.307-.434v-2.507l-.001-.034a.46.46 0 01.454-.461 3.759 3.759 0 002.763-1.261.459.459 0 01.56-.098c.025.015.05.03.075.048a.652.652 0 00.088.036l2.244.77a.46.46 0 01.274.617zm-14.36-1.993a1.925 1.925 0 01-1.923-1.923V25.233c0-1.061.863-1.924 1.923-1.924h8.305c1.061 0 1.924.863 1.924 1.924v11.112a1.925 1.925 0 01-1.924 1.923h-8.305zm6.017 11.472a2.57 2.57 0 01-2.566 2.567 2.57 2.57 0 01-2.567-2.567v-9.124c0-.255.207-.461.461-.461h4.212a.46.46 0 01.46.461v9.124zM47.634 13a3.756 3.756 0 00-3.751 3.751v.401a.46.46 0 01-.311.435l-14.918 5.115a.917.917 0 00-.091.038.472.472 0 01-.293.102.462.462 0 01-.342-.152 3.758 3.758 0 00-2.814-1.267h-8.305A3.814 3.814 0 0013 25.233v11.112a3.82 3.82 0 002.505 3.564.459.459 0 01.302.432v9.399a4.459 4.459 0 004.453 4.453 4.458 4.458 0 004.452-4.453v-3.666a.46.46 0 01.553-.452c.485.1.914.148 1.312.148a6.56 6.56 0 006.348-4.907.461.461 0 01.595-.319l10.052 3.447a.459.459 0 01.311.435v.401a3.756 3.756 0 003.751 3.751 3.756 3.756 0 003.751-3.751V16.751A3.756 3.756 0 0047.634 13z"
        fill="#B3472E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.366 27.038h-2.808a.944.944 0 000 1.886h2.808a.945.945 0 00.943-.943.945.945 0 00-.943-.943zM22.366 32.653h-2.808a.943.943 0 000 1.886h2.808a.944.944 0 000-1.886zM54.653 20.5h1.404A.944.944 0 0057 19.56a.944.944 0 00-.943-.943h-1.404a.943.943 0 000 1.885zM56.057 24.231h-1.404a.944.944 0 000 1.886h1.404a.945.945 0 00.943-.943.945.945 0 00-.943-.943zM56.057 29.846h-1.404a.944.944 0 000 1.886h1.404A.945.945 0 0057 30.79a.945.945 0 00-.943-.943zM56.057 35.46h-1.404a.944.944 0 000 1.887h1.404a.945.945 0 00.943-.943.945.945 0 00-.943-.943zM56.057 41.076h-1.404a.944.944 0 000 1.886h1.404a.945.945 0 00.943-.943.945.945 0 00-.943-.943z"
        fill="#FF7A5C"
      />
    </svg>
  );
}
